if (!customElements.get('wishlist-collection')) {
  class WishlistCollection extends HTMLElement {
    connectedCallback() {
      this.onChange = this.render.bind(this);
      this.render();
      document.addEventListener('susuco:wishlist:change', this.onChange);
    }

    disconnectedCallback() {
      document.removeEventListener('susuco:wishlist:change', this.onChange);
    }

    async render() {
      const handles = window.SusucoWishlist ? window.SusucoWishlist.getAll() : [];

      if (!handles.length) {
        this.renderEmpty();
        return;
      }

      this.innerHTML = '<p class="wishlist-page__loading">Yükleniyor...</p>';

      try {
        const products = await Promise.all(
          handles.map((handle) =>
            fetch(`/products/${handle}.js`)
              .then((res) => (res.ok ? res.json() : null))
              .catch(() => null)
          )
        );

        const validProducts = products.filter(Boolean);

        if (!validProducts.length) {
          this.renderEmpty();
          return;
        }

        this.innerHTML = `<ul class="wishlist-page__grid" role="list">${validProducts
          .map((product) => this.renderCard(product))
          .join('')}</ul>`;

        this.querySelectorAll('[data-wishlist-remove]').forEach((button) => {
          button.addEventListener('click', () => {
            window.SusucoWishlist.remove(button.dataset.wishlistRemove);
          });
        });

        this.querySelectorAll('[data-wishlist-add]').forEach((button) => {
          button.addEventListener('click', (event) => this.addToCart(event));
        });
      } catch (error) {
        console.error('[wishlist]', error);
      }
    }

    renderEmpty() {
      this.innerHTML = `
        <div class="wishlist-page__empty">
          <p>İstek listeniz henüz boş.</p>
          <a href="/collections/all" class="link">Ürünlere göz atın</a>
        </div>
      `;
    }

    renderCard(product) {
      const variant = product.variants && product.variants[0];
      const image = product.featured_image || (product.images && product.images[0]);
      const price = variant ? this.formatMoney(variant.price) : '';

      return `
        <li class="wishlist-page__item">
          <button
            type="button"
            class="wishlist-page__remove"
            data-wishlist-remove="${product.handle}"
            aria-label="İstek listesinden çıkar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <a href="${product.url}" class="wishlist-page__media">
            ${
              image
                ? `<img src="${this.imageUrl(image, 500)}" alt="${this.escapeHtml(product.title)}" loading="lazy">`
                : ''
            }
          </a>
          <div class="wishlist-page__info">
            <a href="${product.url}" class="wishlist-page__title">${this.escapeHtml(product.title)}</a>
            <span class="wishlist-page__price">${price}</span>
          </div>
          ${
            variant
              ? `<button type="button" class="wishlist-page__add" data-wishlist-add data-variant-id="${variant.id}">Sepete Ekle</button>`
              : '<span class="wishlist-page__sold-out">Stokta Yok</span>'
          }
        </li>
      `;
    }

    async addToCart(event) {
      const button = event.currentTarget;
      const variantId = button.dataset.variantId;
      button.disabled = true;
      button.classList.add('is-loading');

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      try {
        const response = await fetch(routes.cart_add_url, config);
        const data = await response.json();

        if (data.status) {
          throw new Error(data.description || data.message || 'cart add failed');
        }

        if (cart) {
          cart.renderContents(data);
        } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist', cartData: data });
        }
      } catch (error) {
        console.error('[wishlist]', error);
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }

    imageUrl(url, size) {
      if (!url) return '';
      return url.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, `_${size}x$1$2`);
    }

    formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.theme?.moneyFormat) {
        return Shopify.formatMoney(cents, window.theme.moneyFormat);
      }
      return `${(cents / 100).toFixed(2)} TL`;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text || '';
      return div.innerHTML;
    }
  }

  customElements.define('wishlist-collection', WishlistCollection);
}
